import React from 'react'
import { Edit } from 'react-admin'
import UpsellingForm from 'ui-shared/Forms/UpsellingForm'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import UpsellingFacetSection from 'ui-shared/Facets/FacetFormSections/UpsellingFacetSection'

const LocationUpsellingEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <UpsellingForm
          relatedProduct="locations"
          facetFields={<UpsellingFacetSection />}
          toolbar={<WithDeleteModalToolbar />}
        />
      </Edit>
    </SectionWrapper>
  )
}

export default LocationUpsellingEdit
